module.exports = __webpack_public_path__ + "media/hallBgm.d34ff093.mp3";